import { UserListModel } from 'src/models/user.models'

// EX-40651
export const definedUserEmails = (
  ...users: (UserListModel | undefined)[]
): string[] =>
  users.flatMap((user) => (user?.email !== undefined ? [user.email] : []))
